import {CareServicesView} from '../../../../../../../components/care-services/care-services-view';

export function ProfessionalCareServicesProfessionalCaregiverScreen() {
  return <CareServicesView mode="caregiver" />;
}
